import { useQuery } from '@tanstack/react-query'
import { api, type Writer } from '@/lib/api'
import { formatCurrency } from '@/lib/utils'

function utilisationColor(pct: number): string {
  if (pct >= 90) return '#EF9F27' // close to budget
  if (pct >= 75) return '#378ADD' // on track
  return '#1D9E75'
}

function Row({ w }: { w: Writer }) {
  const pct = Math.min(100, Math.round((w.spent_cents / w.monthly_budget_cents) * 100))
  return (
    <div>
      <div className="flex justify-between text-xs mb-1">
        <span className="text-ink-primary">{w.name}</span>
        <span className="text-ink-secondary">
          {formatCurrency(w.spent_cents)} / {formatCurrency(w.monthly_budget_cents)}
        </span>
      </div>
      <div className="h-1 bg-surface-muted rounded overflow-hidden">
        <div className="h-full" style={{ width: `${pct}%`, background: utilisationColor(pct) }} />
      </div>
    </div>
  )
}

export function WriterInvoicing() {
  const { data: writers = [] } = useQuery({ queryKey: ['writers'], queryFn: api.writers })
  return (
    <section className="border border-border rounded-md p-3 min-w-0">
      <h2 className="text-sm font-medium mb-2.5">Writer invoicing</h2>
      <div className="flex flex-col gap-2.5">
        {writers.map((w) => <Row key={w.id} w={w} />)}
      </div>
    </section>
  )
}
